import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppService } from 'app/services/app/app.service';
import { environment } from 'environments/environment';
import { Log } from 'app/core/logging/log';
import { SharedModule } from 'app/shared.module';
import { ConfigService } from 'app/services/config/config.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class NavbarComponent implements OnInit {
    public langs = AppService.langs;
    public langSel = AppService.langSel;
    public step: string;
    public environment = environment;

    constructor(
        public location: Location, 
        public appService: AppService,
        public configService: ConfigService,
    ) {

    }

    ngOnInit() {

    }

    isHome() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/home' ) {
            
        }
        else {
            return false;
        }
    }

    isReserve() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        let found = titlee.split('/').find(f=>f=='reserve')!=undefined;
        if(found){
            return true;
        }else{
            return false;
        }
    }

    selectLang(lang:any){
        Log.debug("selectLang", {lang});
        AppService.setLang(lang);
        location.reload();
    }

    logout(){
        AppService.clearToken();
        location.reload();
    }

    getUrlBase(){
        return environment.urlBase;
    }

    getPathHome(){
        if(this.appService.kiosk != null){
            return this.appService.kiosk;
        }
        if(this.appService.clientSelected != null){
            return this.appService.clientSelected.locationCode;
        }
        return 'kiosk';
    }
        
}
